import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ConfigurationService } from 'src/app/components/core/_infrastructure/classes/services/configuration.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { Tc, TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';
import { UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { EnumCodigosTwTcAcciones, EnumIdsTwTcTipoClonacion } from '../../../_importacion/solicitudes/types/enum';
import { FilterSearchingSolicitudExViewModel } from '../../buscadores/solicitudes/buscador-solicitudEx.types';
import { SolicitudExService } from '../datosbasicos/datosbasicosEx.service';
import { DocumentosExService } from '../documentos/documentosEx.service';
import { SolicitudDocumentosExViewModel, TDocumentoSolicitudExViewModel } from '../documentos/documentosEx.types';
import { EnumIdsTcEstadoCertificadoFitoEx, EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../types/enum';
import { EnvioExService } from './envioEx.service';
import { AuxEnvioExViewModel, EPhytoSubmitPostRequest, SolicitudEnvioExViewModel } from './envioEx.types';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-envioex',
    templateUrl: './envioEx.component.html',
    styleUrls: ['./envioEx.component.scss'],
})
export class EnvioExComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    solicitudEx: SolicitudEnvioExViewModel;
    private solicitudDocumentoEx: SolicitudDocumentosExViewModel;

    habilitarEnviar = false;
    habilitarEmitirCF = false;
    habilitarDescargarCF = false;
    habilitarAnularCF = false;
    habilitarEmitirEPhyto = true; //para habilitar o no el botón de emitir ePhyto
    habilitarAnularEPhyto = false;
    habilitarDescargarEphyto = false;

    private pendienteEmitirEphyto = false; //visualiza "ePhyto pendiente de aprobación y emisión" o datos del envío de ePhyto según corresponda
    private inspeccionRealizada = true; //flag que ayuda a sacar mensaje al inspector si entra en Envíos sin haber realizado la inspección
    estadoEsFinalizadoEphyto = false; //verifica si ePhyto finalizado por parte de Traces

    visibilidadCFePhyto = false; //para mostrar el panel de datos del CF tipo ePhyto
    visibilidadCFSede = false; //para mostrar el panel de datos del CF tipo papel
    visualizarGridDocumentos = false; //para visualizar el grid de documentos sólo al inspector
    mostrarDocumentosModoEdicion = false;
    private uploadedFile: UploadedFileViewModel;

    IdSolicitud: number | null = null;
    IdTipoSolicitudEx: number;

    validacionCollection: string[];
    codigoSolicitud: string;
    tituloBoton = 'Enviar';

    esPrevia = false;
    esClonada = false;
    esCanarias = false;

    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    tituloEstadoCertificadoFitoEx: string;
    private strTituloTipoReexportacionNecesarioAdjuntarDoc =
        'Solicitud de Reexportación: Para emitir el ePhyto es necesario marcar la casilla de al menos un documento';
    private messageEPhytoSent = 'EPhyto Enviado y Pendiente de recepción por el país de destino';
    private messageEPhytoAnulado = 'Certificado Fitosanitario anulado correctamente';
    private messageSolicitudSent = 'Solicitud enviada correctamente';
    tituloTipoReexportacionNecesarioAdjuntarDoc = '';

    private laHeGrabadoYo = false;
    mensajeEmision = ''; //mensaje informativo que aparece junto al check verde/atención de envío
    private isAnulacionSustitucion = false;
    private numeroCertificadoToReplace: string | null;
    cSVSedeElectronica = '';

    cols: any[];
    documentosEstandar: TDocumentoSolicitudExViewModel[];
    numeroDocumentos = 0;
    private documentosAttachedEphytoUserCheck: number[] = []; //guarda los Id de los documentos que el usuario marca para adjuntar al ePhyto
    documentosAttachedEphytoBDChecked: TDocumentoSolicitudExViewModel[]; //guarda los Id de los documentos que están guardados en BD como adjuntados al ePhyto
    private ePhytoSubmitPostRequest: EPhytoSubmitPostRequest;

    isCollapsedDatosEnvio = false;
    isCollapsedDatosCF = false;
    isCollapsedDatosEphyto = false;
    isCollapsedDocumentos = false;

    visibilitySpinnerEmitirCF = false;
    visibilitySpinnerAnularCF = false;
    visibilitySpinnerDescargarCF = false;
    visibilitySpinnerEmitirEphyto = false;
    visibilitySpinnerAnularEphyto = false;
    visibilitySpinnerDescargarEphyto = false;
    visibilitySpinnerEnviar = false;
    visibilitySpinnerComprobarEphytos = false;
    visibilityCheckEnvioValue: boolean | null; //flag para mostrar icono check verde, icono de atención o ninguno

    habilitarComprobarEphytos = false;
    habilitarNuevoNumSeguridad = false;
    habilitarNuevaCopiaCF = false;
    listIdioma: Tc[];
    requerirDocumentos = false;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        private fb: UntypedFormBuilder,
        public datepipe: DatePipe,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private navMenuService: NavMenuService,
        protected authService: AuthService,
        private confirmationService: ConfirmationService,
        protected notificacionService: NotificationService,
        protected configurationService: ConfigurationService,
        protected exceptionHandler: ExceptionManager,
        private solicitudExService: SolicitudExService,
        private documentosExService: DocumentosExService,
        private envioExService: EnvioExService,
        private uploaderService: DocumentUploaderService,
        private globalService: GlobalService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudEx = new SolicitudEnvioExViewModel();
        this.ePhytoSubmitPostRequest = new EPhytoSubmitPostRequest();
        this.uploadedFile = new UploadedFileViewModel();
    }

    ngOnInit() {
        this.IdSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.IdSolicitud);

        this.createForm();

        if (this.IdSolicitud) {
            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitudEx', this.IdSolicitud.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());

            this.solicitudExService.isSolicitudUsuario(params).subscribe(result => {
                this.laHeGrabadoYo = result;
            });

            this.loadIdiomaList();

            if (this.isInspector) {
                this.cargarDocumentos();
            }

            this.envioExService.getEnvioSolicitud(this.IdSolicitud).subscribe({
                next: result => {
                    this.solicitudEx = result;
                    this.IdTipoSolicitudEx = result.IdTipoSolicitudEx;

                    this.codigoSolicitud = result.Codigo;

                    this.visibilidadCFePhyto = this.codigoSolicitud !== null && this.solicitudEx?.EsEphyto;
                    this.visibilidadCFSede = this.codigoSolicitud !== null && !this.solicitudEx?.EsEphyto;

                    this.tituloTipoSolicitud = result.TcTipoSolicitudEx.Descripcion;
                    this.esClonada =
                        result.TwSolicitudJerarquiaEx != null && result.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.esCanarias = this.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_CANARIAS;

                    //SI ES PREVIA
                    if (result.EsPrevia) {
                        this.esPrevia = true;
                        if (
                            result.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            result.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += ' - Previa';
                        }
                    }

                    this.tituloEstadoSolicitud = result.TcEstadoSolicitudEx.Descripcion;
                    this.tituloEstadoCertificadoFitoEx = result.TwTcEstadoCertificadoFitoEx.Descripcion;

                    //const found = this.solicitudEx?.TDatosSedeDocBDEx?.find(x=> x.IdCopia == null);
                    //if (found != undefined) {
                    //    this.cSVSedeElectronica = found.Token;
                    //}

                    this.updateForm();

                    const id = this.IdSolicitud ?? 0;
                    this.envioExService.validarSolicitud(id).subscribe(val => {
                        this.validacionCollection = val;
                        this.habilitarAcciones();

                        if (this.inspeccionRealizada && this.pendienteEmitirEphyto) {
                            if (this.isAnulacionSustitucion) {
                                this.solicitudExService.getSolicitudSolo(this.solicitudEx.TwSolicitudJerarquiaEx.IdSolicitudPadre).subscribe(res => {
                                    this.numeroCertificadoToReplace = res.NumeroCertificado;

                                    this.mensajeEmision =
                                        'La solicitud está lista para emitir el ePhyto que anula y sustituye al CF Nº ' + this.numeroCertificadoToReplace;
                                });
                            }
                        }
                    });
                },
                error: error => {
                    this.catchServerError(error);
                },
            });
        }
    }

    private loadIdiomaList(): void {
        if (!this.listIdioma) {
            this.globalService.getIdioma().subscribe(results => {
                this.listIdioma = results;
            });
        }
    }

    private habilitarAcciones(): void {
        //#region SOLICITUD

        this.mensajeEmision = '';
        this.visibilityCheckEnvioValue = null;

        if (this.validacionCollection != null && this.validacionCollection.length > 0) {
            this.mensajeEmision = 'Se necesita completar:';
            this.visibilityCheckEnvioValue = false;
        } else {
            this.habilitarEnviar = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.ENVIAR_SOLICITUD_EXPORTACION,
                this.solicitudEx.IdEstadoSolicitudEx,
            ).Visible;

            this.mensajesInformativosSegunEstados();
        }

        //#endregion SOLICITUD

        if (this.solicitudEx.EsEphyto) {
            //#region EPHYTO

            //Que tenga permiso de enviar ePhyto y además el país de destino admita ePhyto. Si la solicitud es de Reexportación, además tiene que adjuntar algún documento (se controla más adelante)
            this.pendienteEmitirEphyto =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.EMISION_EPHYTO, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE;

            //los documentos sólo se mostrarán editables si el ePhyto está pendiente de emitir y es inspector
            this.mostrarDocumentosModoEdicion = this.pendienteEmitirEphyto && this.isInspector;

            //Botones para emitir el CF/ePhyto. En ambos casos no se puede poner la condición "this.solicitudEx.NumeroCertificado == null" porque a NumeroCertificado le damos valor nosotros antes de enviar y,
            //si falla el envío, va a dejar entonces inhabilitado el botón.
            this.habilitarEmitirEPhyto =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.EMISION_EPHYTO, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE;

            //si el ePhyto está pendiente de emitir, ahora toca ver si se dan las condiciones para habilitar o no el botón de emitir
            if (this.pendienteEmitirEphyto) {
                this.mensajeEmision = 'La solicitud está lista para emitir el ePhyto';

                //si es Reexport y no tiene documentos marcados, sale con habilitarEmitirEPhyto a False
                this.checkHabilitarEmitirEphytoSolicitudReexportacion();

                this.visibilityCheckEnvioValue = this.habilitarEmitirEPhyto;
            }

            this.estadoEsFinalizadoEphyto =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.EMISION_EPHYTO, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME;
            this.habilitarDescargarEphyto =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.DESCARGA_EPHYTO, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.NumeroCertificado != null &&
                (this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME ||
                    this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_ANULADO ||
                    this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_ANULADO_SUSTITUIDO);
            this.habilitarAnularEPhyto =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ANULAR_EPHYTO, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.NumeroCertificado != null &&
                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME;

            this.habilitarComprobarEphytos = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.COMPROBAR_EPHYTOS).Visible;

            //#endregion EPHYTO
        } else {
            //#region CF

            //Botones para emitir el CF/ePhyto. En ambos casos no se puede poner la condición "this.solicitudEx.NumeroCertificado == null" porque a NumeroCertificado le damos valor nosotros antes de enviar y,
            //si falla el envío, va a dejar entonces inhabilitado el botón.
            this.habilitarEmitirCF =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_CF_EXPORTACION, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE;

            this.habilitarAnularCF =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ANULAR_SOLO_CF, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.NumeroCertificado != null &&
                this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME;

            this.habilitarDescargarCF =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.DESCARGAR_CF, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                this.solicitudEx.NumeroCertificado != null &&
                (this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME ||
                    this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_ANULADO);

            //Será el inspector el que pueda dar de alta números de seguridad, siempre que la solicitud esté finalizada conforme, el certificado emitido y finalizado conforme (en papel) o haya copias (ya sea de cf en papel o ephytos)
            this.habilitarNuevoNumSeguridad =
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVO_NUM_SEGURIDAD, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                ((this.solicitudEx.NumeroCertificado != null &&
                    this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME) ||
                    (this.solicitudEx.TSeguridadCertificadoFitoCollection != null && this.solicitudEx.TSeguridadCertificadoFitoCollection.length > 0));

            //#endregion CF
        }

        //comunes, da igual si es CF o ePhyto
        this.habilitarNuevaCopiaCF =
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVA_BORRAR_COPIA_CF, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
            this.solicitudEx.IdEstadoCertificadoFitoEx == EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME;

        //en PPIO es para los ePhytos, pero quedará por ver los CF...
        if (
            this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_ANULADA &&
            this.solicitudEx.TwSolicitudJerarquiaEx != null &&
            this.solicitudEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_ANULACION_SUSTITUCION
        ) {
            this.isAnulacionSustitucion = true;
        }
    }

    private mensajesInformativosSegunEstados(): void {
        let esRolSolicitante = (this.isGrabador && this.laHeGrabadoYo) || this.isSolicitante;
        let cadena = '';

        //AQUÍ SE PUEDE DAR MÁS INFORMACIÓN AL SOLICITANTE SI, POR EJEMPLO, LAS PREVIAS.... ¿¿??
        switch (this.solicitudEx.IdEstadoSolicitudEx) {
            case EnumIdsTcEstadoSolicitudEx.ID_BORRADOR:
                this.mensajeEmision = 'La solicitud está lista para ser enviada';
                this.visibilityCheckEnvioValue = true; //check verde
                break;

            case EnumIdsTcEstadoSolicitudEx.ID_NUEVA:
            case EnumIdsTcEstadoSolicitudEx.ID_EN_TRAMITE:
            case EnumIdsTcEstadoSolicitudEx.ID_REVISADO_SOLICITANTE:
                if (esRolSolicitante) {
                    this.mensajeEmision = 'Solicitud enviada';
                    this.visibilityCheckEnvioValue = true; //check verde
                }
                if (this.isInspector) {
                    this.mensajeEmision = 'Se necesita completar: el apartado de inspecciones'; //detectar si solicitud aún no inspeccionada, para mostrar mensaje al inspector
                    this.visibilityCheckEnvioValue = false; //check atención
                    this.inspeccionRealizada = false; //para que no continúe aunque se cumplan otras condiciones, ya que tener la inspección realizada es imprescindible
                }
                break;

            case EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE:
                if (esRolSolicitante) {
                    this.mensajeEmision = 'La solicitud tiene que ser revisada por el solicitante';
                    this.visibilityCheckEnvioValue = false; //check atención
                }
                if (this.isInspector) {
                    this.mensajeEmision = 'La solicitud ha sido devuelta al solicitante';
                    this.visibilityCheckEnvioValue = false; //check atención
                }
                break;

            case EnumIdsTcEstadoSolicitudEx.ID_RECHAZADA_INSPECTOR:
                this.mensajeEmision = 'Solicitud rechazada';
                this.visibilityCheckEnvioValue = false; //check atención
                break;

            case EnumIdsTcEstadoSolicitudEx.ID_ANULADA:
                this.mensajeEmision = 'Solicitud anulada';
                this.visibilityCheckEnvioValue = false; //check atención
                break;

            case EnumIdsTcEstadoSolicitudEx.ID_FINALIZADA_CONFORME:
                if (this.solicitudEx.EsEphyto) {
                    cadena = 'Ephyto';
                } else {
                    cadena = 'Certificado Fitosanitario';
                }

                switch (this.solicitudEx.IdEstadoCertificadoFitoEx) {
                    case EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE:
                        this.mensajeEmision = cadena + ' pendiente de emisión y aprobación';
                        this.visibilityCheckEnvioValue = false; //check atención
                        break;

                    case EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_EPHYTO:
                    case EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_ANULACION_EPHYTO:
                    case EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_ANULACION_SUSTITUCION_EPHYTO:
                        this.mensajeEmision = cadena + ' enviado y pendiente de aprobación';
                        this.visibilityCheckEnvioValue = true; //check verde
                        break;

                    default:
                        break;
                }

                break;

            default:
                this.mensajeEmision = 'La solicitud está lista para ser enviada';
                this.visibilityCheckEnvioValue = true; //check verde
                break;
        }
    }

    private cargarDocumentos(): void {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Autogenerado', header: 'Autogenerado', display: 'none' },
            { field: 'AttachedEphyto', header: 'AttachedEphyto', display: 'none' },
            { field: 'IdTipoDocumentacionExDescripcion', header: 'Tipo' },
            { field: 'Texto', header: 'Número' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'Perfil', header: 'Perfil' },
        ];

        this.visualizarGridDocumentos = true;
        this.documentosAttachedEphytoBDChecked = [];

        this.loading = true;

        const id = this.IdSolicitud ?? 0;
        this.documentosExService.getSolicitudDocumentos(id).subscribe(result => {
            this.solicitudDocumentoEx = result;

            //Filtro los documentos que son estandar
            this.documentosEstandar = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection.filter(x => x.EsAlegacion == false);
            this.numeroDocumentos = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection!.length;
            this.loading = false;

            if (this.solicitudDocumentoEx.TDocumentoSolicitudExCollection != null && this.solicitudDocumentoEx.TDocumentoSolicitudExCollection.length > 0) {
                //los documentos anexados al ePhyto se guardan en una colección para luego mostrarlos chequeados en el grid de documentos
                this.documentosAttachedEphytoBDChecked = this.solicitudDocumentoEx.TDocumentoSolicitudExCollection.filter(x => x.AttachedEphyto);
            }
        });
    }

    onRowSelect(event: any): void {
        this.documentosAttachedEphytoUserCheck.push(event.data.Id);
        this.checkHabilitarEmitirEphytoSolicitudReexportacion();
    }

    onRowUnselect(event: any): void {
        this.documentosAttachedEphytoUserCheck.splice(this.documentosAttachedEphytoUserCheck.indexOf(event.data.Id), 1);
        this.checkHabilitarEmitirEphytoSolicitudReexportacion();
    }

    selectAllRows(event: any): void {
        if (event.checked) {
            this.documentosAttachedEphytoUserCheck = [];
            this.documentosEstandar.forEach(x => this.documentosAttachedEphytoUserCheck.push(x.Id));
        } else {
            this.documentosAttachedEphytoUserCheck = [];
        }
        //tipo reexportación, al menos debe adjuntar un documento, el botón se habilita según haya o no documentos adjuntados
        this.checkHabilitarEmitirEphytoSolicitudReexportacion();
    }

    private checkHabilitarEmitirEphytoSolicitudReexportacion(): void {
        if (this.solicitudEx.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION) {
            //tipo reexportación, al menos debe adjuntar un documento, el botón se habilita según haya o no documentos adjuntados
            this.habilitarEmitirEPhyto = this.documentosAttachedEphytoUserCheck.length > 0 ? true : false;

            if (this.habilitarEmitirEPhyto) {
                this.tituloTipoReexportacionNecesarioAdjuntarDoc = '';
                this.visibilityCheckEnvioValue = true; //check verde
                this.mensajeEmision = 'ePhyto Pendiente de emisión y aprobación';
                this.requerirDocumentos = false;
            } else {
                this.tituloTipoReexportacionNecesarioAdjuntarDoc = this.strTituloTipoReexportacionNecesarioAdjuntarDoc;
                this.visibilityCheckEnvioValue = false; //check atención
                this.mensajeEmision = this.tituloTipoReexportacionNecesarioAdjuntarDoc;
                this.requerirDocumentos = true;
            }
        }
    }

    //Para pipe de visualización de iconos en tabla documentos
    //Columna Autogenerado de tabla TDocumentoSolicitudEx: Diferencia los emitidos automáticamente por el sistema de los subidos manualmente por los usuarios
    //      Autogenerado + CF       icono de Sede Electrónica del MAPA
    //      Autogenerado + ePhyto   icono de Descargado desde TRACES
    //Columna AttachedEphyto de tabla TDocumentoSolicitudEx: Indica si un documento se ha anexado al ePhyto para su envío a Traces
    isTracesInfoVisible(item: TDocumentoSolicitudExViewModel, field: string): any {
        switch (field) {
            case 'Autogenerado':
                return item.Autogenerado;

            case 'AttachedEphyto':
                return item.AttachedEphyto;
        }
    }

    onDownload(item: TDocumentoSolicitudExViewModel): void {
        this.uploadedFile.Guid = item.CodigoStorage;
        this.uploadedFile.Name = item.NombreArchivo;

        this.uploaderService.download(this.uploadedFile).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    private guardRefreshPage(id: number): void {
        //Fuerzo que lo haga siempre pq fallaba al refrescar cuando cambiaba de estado
        if (id) {
            this.solicitudExService.getSolicitudSolo(id).subscribe(result => {
                this.navMenuService.currentSolicitudExportacion = result;
            });
        }
    }

    private createForm(): void {
        this.form = this.fb.group({
            Codigo: '',
            FechaEnvio: null,
            FechaPresentacion: null,
            FechaCertificacion: '',
            NumeroCertificado: '',
            EstadoCert: '',
            Token: '',
            Pin: '',
            IdIdiomaCF: null,
            IdIdiomaEphyto: null,
            IdiomaCFDescripcion: '',
            IdiomaEphytoDescripcion: '',
            Utilizado: '',
            Disponible: '',
        });
    }

    private updateForm(): void {
        this.form.setValue({
            Codigo: this.solicitudEx.Codigo,
            FechaEnvio: this.datepipe.transform(this.solicitudEx.FechaEnvio, 'dd/MM/yyyy'),
            FechaPresentacion: this.datepipe.transform(this.solicitudEx.FechaPresentacion, 'dd/MM/yyyy'),
            FechaCertificacion: this.datepipe.transform(this.solicitudEx.FechaCertificacion, 'dd/MM/yyyy'),
            NumeroCertificado: this.solicitudEx.NumeroCertificado,
            EstadoCert: this.solicitudEx.TwTcEstadoCertificadoFitoEx.Descripcion,
            Token: this.solicitudEx.TDatosSedeDocBDEx != null ? this.solicitudEx.TDatosSedeDocBDEx.Token : null,
            Pin: this.solicitudEx.TClaveCertCanarias != null ? this.solicitudEx.TClaveCertCanarias.Pin : '',
            IdIdiomaCF: this.solicitudEx?.IdIdioma,
            IdIdiomaEphyto: this.solicitudEx?.IdIdioma,
            IdiomaCFDescripcion: this.solicitudEx?.IdiomaDescripcion,
            IdiomaEphytoDescripcion: this.solicitudEx?.IdiomaDescripcion,
            Utilizado: this.solicitudEx?.CfUtilizado == true ? 'SI' : 'NO',
            Disponible: this.solicitudEx?.CfDisponible == true ? 'SI' : 'NO',
        });
    }

    enviarSolicitud(): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de enviar la solicitud?',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onComprobarEstadosEphyto(): void {
        this.visibilitySpinnerComprobarEphytos = true;

        let model: FilterSearchingSolicitudExViewModel = new FilterSearchingSolicitudExViewModel();
        model.IdUsuario = this.loggedInUser!.Id;
        model.EsInspector = true;

        this.envioExService.comprobarEstadosEphytos(model).subscribe({
            next: () => {
                //para actualizar los iconos de los estados
                this.ngOnInit();
                this.visibilitySpinnerComprobarEphytos = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerComprobarEphytos = false;
            },
        });
    }

    onBack(): void {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', this.IdSolicitud]);
    }

    private onSubmit(): void {
        this.submitted = true;
        this.visibilitySpinnerEnviar = true;

        //VUELVO A VALIDAR
        this.envioExService.validarSolicitud(this.solicitudEx.Id).subscribe({
            next: result1 => {
                this.validacionCollection = result1;

                //Si no es PREVIA, o si es una PREVIA que ya dejó de serlo (y tiene código de solicitud)
                if (!this.solicitudEx.EsPrevia || (this.solicitudEx.EsPrevia && this.solicitudEx.Codigo != null)) {
                    //Si no hay errores llamo a ValidateTraces
                    if (this.validacionCollection.length == 0) {
                        this.envioExService.envioSolicitud(this.solicitudEx.Id).subscribe({
                            next: () => {
                                this.addSuccessMessage(this.messageSolicitudSent);
                                this.IdSolicitud = null;
                                this.changeDetectorRef.detectChanges(); //fuerza la detección de cambios para mostrar el componente de las alertas
                                this.ngOnInit();
                                this.visibilitySpinnerEnviar = false;
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinnerEnviar = false;
                            },
                        });
                    }
                } else {
                    //Si no hay errores ENVIO
                    this.envioExService.envioSolicitud(this.solicitudEx.Id).subscribe({
                        next: () => {
                            this.addSuccessMessage(this.messageSolicitudSent);
                            this.IdSolicitud = null;
                            this.changeDetectorRef.detectChanges(); //fuerza la detección de cambios para mostrar el componente de las alertas
                            this.ngOnInit();
                            this.visibilitySpinnerEnviar = false;
                        },
                        error: error => {
                            this.catchServerError(error);
                            this.visibilitySpinnerEnviar = false;
                        },
                    });
                }
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerEnviar = false;
            },
        });

        this.validacionCollection = [];

        //piden que cuando el inspector envíe a Traces el ePhyto, se aproveche para preguntar por el estado de los ePhytos ya enviados porque no se acuerdan de darle al botón en el buscador
        let model: FilterSearchingSolicitudExViewModel = new FilterSearchingSolicitudExViewModel();
        model.IdUsuario = this.loggedInUser!.Id;
        model.EsInspector = false;

        this.envioExService.comprobarEstadosEphytos(model).subscribe(() => {
            // do nothing
        });
    }

    nuevaCopiaCF(): void {
        this.router.navigate(['/exportacion/solicitud/envioEx/', this.solicitudEx.Id, 'createCopiaCF']);
    }

    nuevoNumSeguridad(): void {
        this.router.navigate(['/exportacion/solicitud/envioEx/', this.solicitudEx.Id, 'createNumSeguridad']);
    }

    //#region   C E R T I F I C A D O   F I T O S A N I T A R I O

    onChangeIdiomaCF(): void {
        this.solicitudEx.IdIdioma = this.form.controls['IdIdiomaCF'].value;
    }

    onEmitirCF(): void {
        this.visibilitySpinnerEmitirCF = true;

        let model: AuxEnvioExViewModel = new AuxEnvioExViewModel();
        model.IdSolicitudEx = this.solicitudEx.Id;
        model.IdUsuario = this.loggedInUser!.Id;
        model.IdIdioma = this.solicitudEx.IdIdioma;

        this.envioExService.exportCertificadoFitosanitario(model).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
                this.visibilitySpinnerEmitirCF = false;
                this.habilitarEmitirCF = false;
                this.ngOnInit();
            },
            error: error => {
                this.catchServerError(error);
                //this.visibilitySpinnerAnularCF = false;
                this.visibilitySpinnerEmitirCF = false;
                // this.habilitarEmitirCF = false;
            },
        });
    }

    onAnularCF(): void {
        this.visibilitySpinnerAnularCF = true;
        this.confirmationService.confirm({
            message:
                '¿Está seguro de anular el Certificado Fitosanitario de esta solicitud?.\n\nTenga en cuenta que también se anularán todas las copias y que no\npodrá deshacer la operación.',
            accept: () => {
                let model: AuxEnvioExViewModel = new AuxEnvioExViewModel();
                model.IdSolicitudEx = this.solicitudEx.Id;
                model.IdUsuario = this.loggedInUser!.Id;
                model.IdIdioma = this.solicitudEx.IdIdioma;

                this.envioExService.anularCertificadoFitoEx(model).subscribe({
                    next: res => {
                        this.OpenDownloadedFile(res);
                        this.visibilitySpinnerAnularCF = false;
                        this.habilitarAnularCF = false;
                        this.addSuccessMessage(this.messageEPhytoAnulado);
                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                        this.visibilitySpinnerAnularCF = false;
                        // this.habilitarAnularCF = false;
                    },
                });
            },
        });
    }
    //#endregion   C E R T I F I C A D O   F I T O S A N I T A R I O

    //#region  E P H Y T O

    onChangeIdiomaEphyto(): void {
        this.solicitudEx.IdIdioma = this.form.controls['IdIdiomaEphyto'].value;
    }

    sendEphytoOnDemand(): void {
        this.visibilitySpinnerEmitirEphyto = true;
        // this.estadoEsEnviadoEphyto = true;

        if (this.isAnulacionSustitucion) {
            const id = this.IdSolicitud ?? 0;
            this.envioExService.cancelReplaceEphytoOnDemand(id).subscribe({
                next: res => {
                    if (res.Status == 1) {
                        this.notificacionService.addSuccessMessage(res.Description);
                        //this.visibilityCheckEnvioEphyto = false;
                        this.visibilityCheckEnvioValue = true;
                        this.mensajeEmision = this.messageEPhytoSent;
                        this.habilitarEmitirEPhyto = false;
                    } else {
                        this.notificacionService.addErrorMessage(res.Description);
                    }
                    this.visibilitySpinnerEmitirEphyto = false;
                    //para actualizar los iconos de los estados
                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinnerEmitirEphyto = false;
                },
            });
        } else {
            const id = this.IdSolicitud ?? 0;
            this.ePhytoSubmitPostRequest.IdSolicitudEx = id;
            this.ePhytoSubmitPostRequest.IdIdioma = this.solicitudEx.IdIdioma;
            this.ePhytoSubmitPostRequest.DocumentosIdList = this.documentosAttachedEphytoUserCheck;

            this.envioExService.sendEphytoOnDemand(this.ePhytoSubmitPostRequest).subscribe({
                next: res => {
                    if (res.Status == 1) {
                        this.notificacionService.addSuccessMessage(res.Description);
                        this.visibilityCheckEnvioValue = true;
                        this.mensajeEmision = this.messageEPhytoSent;
                        this.habilitarEmitirEPhyto = false;
                    } else {
                        this.notificacionService.addErrorMessage(res.Description);
                    }
                    this.visibilitySpinnerEmitirEphyto = false;
                    //para actualizar los iconos de los estados
                    this.ngOnInit();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinnerEmitirEphyto = false;
                },
            });
        }

        //piden que cuando el inspector envíe a Traces el ePhyto, se aproveche para preguntar por el estado de los ePhytos ya enviados porque no se acuerdan de darle al botón en el buscador
        let model: FilterSearchingSolicitudExViewModel = new FilterSearchingSolicitudExViewModel();
        model.IdUsuario = this.loggedInUser!.Id;
        model.EsInspector = true;

        this.envioExService.comprobarEstadosEphytos(model).subscribe(() => {
            // do nothing
        });
    }

    cancelEphytoOnDemand(): void {
        this.visibilitySpinnerAnularEphyto = true;

        const id = this.IdSolicitud ?? 0;
        this.envioExService.cancelEphytoOnDemand(id).subscribe({
            next: res => {
                if (res.Status == 1) {
                    this.notificacionService.addSuccessMessage(res.Description);
                    this.visibilityCheckEnvioValue = true;
                    this.mensajeEmision = this.messageEPhytoSent;
                    this.habilitarAnularEPhyto = false;
                } else {
                    this.notificacionService.addErrorMessage(res.Description);
                }
                this.visibilitySpinnerAnularEphyto = false;
                //para actualizar los iconos de los estados
                this.ngOnInit();
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinnerAnularEphyto = false;
            },
        });

        //piden que cuando el inspector envíe a Traces el ePhyto, se aproveche para preguntar por el estado de los ePhytos ya enviados porque no se acuerdan de darle al botón en el buscador
        let model: FilterSearchingSolicitudExViewModel = new FilterSearchingSolicitudExViewModel();
        model.IdUsuario = this.loggedInUser!.Id;
        model.EsInspector = true;

        this.envioExService.comprobarEstadosEphytos(model).subscribe(() => {
            // do nothing
        });
    }

    //#endregion  E P H Y T O
}
